import { Variants } from "@kameleon-util/global-theme";
import React, { ReactElement } from "react";
import { Shared } from "@kameleon-core/lib";

export const getLogosToRender = (logos: Shared.Props.MediaProp[]) => {
  let duplicatedLogos = [...logos];
  while (duplicatedLogos.length < 16) {
    duplicatedLogos = duplicatedLogos.concat([...logos]);
  }
  return duplicatedLogos;
};

export const renderLogos = (
  logos: Shared.Props.MediaProp[],
  layoutProps: any
): ReactElement => (
  <div className="logo3_list">
    {getLogosToRender(logos).map((logo, i) => (
      <Variants.BoxGrey
        variant={`${
          !layoutProps.itemBackground ? "" : "boxes.backgrounds.grey"
        }`}
        key={`${logo}-${i}`}
        className="logo3_wrapper"
      >
        <Variants.Image
          src={logo.url}
          loading="lazy"
          alt={logo.alt}
          className="logo3_logo"
        />
      </Variants.BoxGrey>
    ))}
  </div>
);
